module.exports = __webpack_public_path__ + "static/logo-new-430b234f0713b7ec60e53f7c764b1096.jpg";